import React from "react"
import Select from "react-select"

class AttributeSelect extends React.Component {
  state = {
    selectedOption: null
  }
  
  render() {
    const { selectedOption } = this.state
    const { label, setParentAttribute, options } = this.props
    
    const handleChange = selectedOption => {
      this.setState({ selectedOption })
      setParentAttribute(selectedOption)
    }
    
    return (<div className="form-group">
      <div id={`${label}-label`}>{label}</div>
      <Select options={options} name="fur" className="parent-select-container" onChange={handleChange} value={selectedOption} aria-labelledby={label} isSearchable={false} />
    </div>)
  }
}

export default AttributeSelect